import { ProfileLayout } from "../Container/Layout";
import React, {
  FormEventHandler,
  useContext,
  useState,
} from "react";
import { TransactionPostCoach } from "../Services/Transactions";
import { MainContext, ProfileContext } from "../Context";
import { Button } from "../Components/Base";
import { useNavigate } from "react-router";
import { Toast } from "../Utils";

const CoachRegister = () => {
  const navigate = useNavigate();

  const { profile } = useContext(ProfileContext);
  const { townList } = useContext(MainContext);

  // ===========================================================================

  const [gymName, setGymName] = useState<string>();
  const [gymAddress, setGymAddress] = useState<string>();
  const [town_id, setTown_id] = useState(0);
  const [resume, setResume] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // ===========================================================================

  const resetForm = () => {
    setGymName("");
    setGymAddress("");
    setTown_id(0);
    setResume(null);
  };

  const formIsValid = () => {
    return gymName && gymAddress && town_id;
  };

  const handleSubmitForm: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    if (profile.personalVerification) {
      if (formIsValid()) {
        const form = new FormData();
        form.append("gymName", gymName!);
        form.append("gymAddress", gymAddress!);
        form.append("town_id", town_id.toString());
        if (resume) {
          form.append("resume", resume);
        }
        setIsLoading(true);
        TransactionPostCoach(form)
          .then(({ data: res }) => {
            if (res.transaction_status) {
              resetForm();
              Toast("success", "درخواست شما با موفقیت ثبت شد.");
            } else {
              Toast("error", res.message);
            }
          })
          .finally(() => setIsLoading(false));
      } else {
        Toast("error", "لطفا ابتدا فیلد ها را پر کنید.");
      }
    } else {
      navigate("/profile");
    }
  };

  // ===========================================================================

  return (
    <ProfileLayout>
      <div className="col-12">
        <div className="card border mb-4">
          <div className="card-header border-bottom p-3">
            <h4 className="card-header-title mb-0">ثبت نام به عنوان مربی</h4>
          </div>
          <form onSubmit={handleSubmitForm} className="card-body">
            <div className="mb-3">
              <label className="form-label">نام باشگاه</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={gymName}
                  onChange={(e) => setGymName(e.target.value)}
                  placeholder="نام باشگاه خود را وارد کنید"
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">آدرس باشگاه</label>
              <textarea
                value={gymAddress}
                onChange={(e) => setGymAddress(e.target.value)}
                className="form-control resize-none"
                maxLength={500}
                rows={4}
              >
                {gymAddress}
              </textarea>
              <div className="form-text">آدرس باشگاه خود را وارد کنید.</div>
            </div>

            <div className="mb-3">
              <label className="form-label">استان</label>
              <select
                onChange={(e) => setTown_id(Number(e.target.value))}
                className="form-select cursor-pointer"
                value={town_id}
              >
                <option value={0}>انتخاب کنید</option>
                {townList.map((town) => (
                  <option key={town.id} value={town.id}>{town.name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="formFile" className="form-label">
                فایل رزومه ( PDF, JPEG, JPG, PNG )
              </label>
              <input
                accept=".pdf,.jpeg,.jpg,.png"
                className="form-control"
                type="file"
                onChange={(e) => setResume(e.target.files?.[0] || null)}
                id="formFile"
              />
            </div>

            <div className="d-flex w-100 justify-content-end mt-4">
              <Button
                text={
                  profile.personalVerification ? "ثبت درخواست" : "احراز هویت"
                }
                disabled={!formIsValid()}
                isLoading={isLoading}
                btnClass="btn w-100 btn-primary"
              />
            </div>
          </form>
        </div>
      </div>
    </ProfileLayout>
  );
};

export default CoachRegister;
